var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "#3E3E3E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9547 6.21186C15.3181 6.25145 15.5997 5.90045 15.4824 5.55426L13.7321 0.391924C13.6053 0.0180653 13.1157 -0.068347 12.8686 0.239545L11.5798 1.84563C10.4185 1.26453 9.12695 0.971955 7.81596 1.00212C6.07962 1.04208 4.40345 1.64601 3.04065 2.72268C1.67784 3.79936 0.702437 5.29029 0.261779 6.97025C-0.17888 8.65022 -0.0608537 10.428 0.598027 12.0349C1.25691 13.6419 2.42085 14.9908 3.91403 15.8779C5.40721 16.7649 7.14851 17.142 8.87489 16.952C10.6013 16.7621 12.2189 16.0155 13.4836 14.825C14.6265 13.7491 15.4249 12.3633 15.7848 10.8429C15.8485 10.5742 15.6641 10.3152 15.392 10.2685L14.4328 10.1039C14.1606 10.0572 13.9042 10.2407 13.8351 10.5081C13.5513 11.6065 12.962 12.6061 12.1311 13.3883C11.1784 14.2852 9.95968 14.8476 8.6591 14.9907C7.35853 15.1338 6.04671 14.8497 4.92181 14.1815C3.79692 13.5132 2.92006 12.497 2.42369 11.2864C1.92732 10.0758 1.8384 8.73649 2.17037 7.47088C2.50235 6.20527 3.23717 5.08207 4.26385 4.27095C5.29052 3.45984 6.55328 3.00486 7.86135 2.97476C8.70448 2.95536 9.53692 3.11315 10.3068 3.4321L9.19996 4.81146C8.9529 5.11935 9.14334 5.57868 9.53578 5.62144L14.9547 6.21186Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.780b28baf050fcaeab0e5d8642813458.svg";
export { ForwardRef as ReactComponent };